/** Sales workspace sub-pages (sidebar under Sales). */
export const SALES_MODULES = {
  link: {
    key: "link",
    tab: "sales",
    eyebrow: "Sales · Link",
    title: "Sales Link",
    description:
      "Link outward vehicles to party and sales contract after gate registration, before tare weigh.",
    testId: "sales-link-page",
  },
  loading: {
    key: "loading",
    tab: "loading",
    eyebrow: "Sales · Loading",
    title: "Loading",
    description:
      "Confirm bags loaded after tare weigh. Stock for the selected pack size is decremented on confirm.",
    testId: "sales-loading-page",
  },
  voucher: {
    key: "voucher",
    tab: "accounts",
    eyebrow: "Sales · Voucher",
    title: "Sales Voucher",
    description:
      "At dispatch: issue provisional sales. After goods receipt / lab, finalize settlement and post the adjustment journal to Tally.",
    testId: "sales-voucher-page",
  },
};

export function salesModuleFromKey(key) {
  return SALES_MODULES[key] || SALES_MODULES.link;
}
